import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import moment from 'moment';
import { ApprovalStatus } from 'api/approval';
import { TaskStatusType } from 'api/status-updates';
import { StatusGroup } from 'api/tasks';
const isTaskOverdue = (date, task)=>{
    // Don't consider tasks that are due Today or in upcoming days.
    const toDate = moment(date[1]);
    const fromDate = moment(date[0]);
    const rangeEnd = toDate.isBefore(moment().startOf('d')) ? toDate : moment().subtract(1, 'days').endOf('d');
    // Move start also to correct position, otherwise start may be after the end.
    const rangeStart = fromDate.isBefore(rangeEnd) ? fromDate : rangeEnd;
    return !!(date[0] && date[1] && task.dueDate && moment(task.dueDate).isBetween(rangeStart, rangeEnd) && !task.completedAt);
};
const isTaskCompleted = (date, task)=>{
    return !!(date[0] && date[1] && task.completedAt && moment(task.completedAt).isBetween(moment(date[0]), moment(date[1])));
};
const isTaskBlocked = (date, task, blockedStatusField)=>{
    var _blockedStatusField_metaData, _taskStatusField_metaFieldValue;
    const taskStatusField = task.fields.find(// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    (f)=>f.fieldId === (blockedStatusField === null || blockedStatusField === void 0 ? void 0 : blockedStatusField.fieldId));
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    const blockedFieldValue = blockedStatusField === null || blockedStatusField === void 0 ? void 0 : (_blockedStatusField_metaData = blockedStatusField.metaData) === null || _blockedStatusField_metaData === void 0 ? void 0 : _blockedStatusField_metaData.options.find((x)=>x.group === StatusGroup.Blocked);
    return (taskStatusField === null || taskStatusField === void 0 ? void 0 : (_taskStatusField_metaFieldValue = taskStatusField.metaFieldValue) === null || _taskStatusField_metaFieldValue === void 0 ? void 0 : _taskStatusField_metaFieldValue.group) === (blockedFieldValue === null || blockedFieldValue === void 0 ? void 0 : blockedFieldValue.group);
};
const isTaskUpcoming = (date, task)=>{
    return !!(date[0] && date[1] && task.dueDate && moment(task.dueDate).isBetween(moment(date[0]), moment(date[1])));
};
const isTaskInProgress = (date, task, progressStatusField)=>{
    var _progressStatusField_metaData, _taskStatusField_metaFieldValue;
    const taskStatusField = task.fields.find(// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    (f)=>f.fieldId === (progressStatusField === null || progressStatusField === void 0 ? void 0 : progressStatusField.fieldId));
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    const progressFieldValue = progressStatusField === null || progressStatusField === void 0 ? void 0 : (_progressStatusField_metaData = progressStatusField.metaData) === null || _progressStatusField_metaData === void 0 ? void 0 : _progressStatusField_metaData.options.find((x)=>x.group === StatusGroup.InProgress);
    return (taskStatusField === null || taskStatusField === void 0 ? void 0 : (_taskStatusField_metaFieldValue = taskStatusField.metaFieldValue) === null || _taskStatusField_metaFieldValue === void 0 ? void 0 : _taskStatusField_metaFieldValue.group) === (progressFieldValue === null || progressFieldValue === void 0 ? void 0 : progressFieldValue.group);
};
export const isTaskMatchesFilter = (taskStatus, date, task, statusField)=>{
    switch(taskStatus){
        case TaskStatusType.Completed:
            return isTaskCompleted(date, task);
        case TaskStatusType.Blocked:
            return isTaskBlocked(date, task, statusField);
        case TaskStatusType.Overdue:
            return isTaskOverdue(date, task);
        case TaskStatusType.Upcoming:
            return isTaskUpcoming(date, task);
        case TaskStatusType.InProgress:
            return isTaskInProgress(date, task, statusField);
        default:
            return false;
    }
};
const isTaskApprovalOverdue = (date, approval)=>{
    return !!(date[0] && date[1] && approval.dueDate && moment(approval.dueDate).isBetween(moment(date[0]), moment(date[1])) && some(approval.requestTo, [
        'approvalStatus',
        ApprovalStatus.ApprovalRequested
    ]));
};
const isTaskApprovalCompleted = (date, approval)=>{
    const approvedReq = find(approval.requestTo, [
        'approvalStatus',
        ApprovalStatus.Approved
    ]);
    return !!(date[0] && date[1] && !isEmpty(approvedReq) && moment(approvedReq === null || approvedReq === void 0 ? void 0 : approvedReq.updateAt).isBetween(moment(date[0]), moment(date[1])));
};
const isTaskApprovalUpcoming = (date, approval)=>{
    return !!(date[0] && date[1] && approval.dueDate && moment(approval.dueDate).isBetween(moment(date[0]), moment(date[1])));
};
export const isTaskApprovalMatchesFilter = (taskStatus, date, approval)=>{
    switch(taskStatus){
        case TaskStatusType.Completed:
            return isTaskApprovalCompleted(date, approval);
        case TaskStatusType.Overdue:
            return isTaskApprovalOverdue(date, approval);
        case TaskStatusType.Upcoming:
            return isTaskApprovalUpcoming(date, approval);
        default:
            return false;
    }
};
export const isCorrectDateRange = (date)=>date.every((val)=>typeof val === 'number' && !Number.isNaN(val) && val > 0);
